import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import Desktop from './desktop';
import Mobile from './mobile';
import useComponent from './useComponent';

const WorkSpaceDetail = () => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 992;
  });

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const { w_id } = useParams();
  const viewModel = useComponent({ w_id });

  return isMobile ? <Mobile viewModel={viewModel} /> : <Desktop viewModel={viewModel} />;
};

export default WorkSpaceDetail;
